import ApiService from "@/core/services/api.service";

// action types
export const FETCH_ADMIN_USERS = "fetchAdminUsers";
export const FETCH_ADMIN_USER = "fetchAdminUser";
export const STORE_ADMIN_USER = "storeAdminUser";
export const UPDATE_ADMIN_USER = "updateAdminUser";
export const DESTROY_ADMIN_USER = "destroyAdminUser";
export const UPDATE_PASSWORD_USER_ADMIN = "updatePasswordUser";

// mutation types
export const SET_ADMIN_USERS = "setAdminUsers";
export const SET_ADMIN_USERS_PAGINATION = "setAdminUsersPagination";
export const SET_ADMIN_USERS_PAGINATION_PAGE = "setAdminUsersPaginationPage";
export const SET_ADMIN_USERS_SORT = "setAdminUsersSort";
export const SET_ADMIN_USER = "setAdminUser";

const state = {
  adminUsers: [],
  adminUsersPagination: {
    total: 0,
    currentPage: 1,
    firstPage: 1,
    lastPage: 1,
    perPage: 0
  },
  sort: {
    col: "id",
    dir: "desc"
  },
  adminUser: {}
};

const getters = {
  adminUsers(state) {
    return state.adminUsers;
  },
  adminUsersPagination(state) {
    return state.adminUsersPagination;
  },
  adminUser(state) {
    return state.adminUser;
  }
};

const actions = {
  [FETCH_ADMIN_USERS](context, payload) {
    let params = {
      page: context.state.adminUsersPagination.currentPage,
      company: payload.company
    };

    if (payload.sort && payload.sort.col !== undefined) {
      params.sort = payload.sort;
    } else {
      params.sort = context.state.sort;
    }

    if (typeof payload.cellphone == "string") {
      params.cellphone = payload.cellphone.replace(/^09/, "+989");
    }

    return new Promise((resolve, reject) => {
      ApiService.query("admin/users", {
        params: params
      })
        .then(({ data }) => {
          context.commit(SET_ADMIN_USERS, data.data);
          context.commit(SET_ADMIN_USERS_PAGINATION, {
            total: data["total"],
            currentPage: data["current_page"],
            firstPage: data["first_page"],
            lastPage: data["last_page"],
            perPage: data["per_page"]
          });
          if (payload.sort && payload.sort.col !== undefined) {
            context.commit(SET_ADMIN_USERS_SORT, payload.sort);
          }
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [FETCH_ADMIN_USER](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.query("profile", {
        params: {
          user: id
        }
      })
        .then(({ data }) => {
          context.commit(SET_ADMIN_USER, data);
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [STORE_ADMIN_USER](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post("admin/users", payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [UPDATE_ADMIN_USER](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.put("profile", payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [DESTROY_ADMIN_USER](context, id) {
    return new Promise(resolve => {
      ApiService.delete(`admin/users/${id}`).then(({ data }) => {
        resolve(data);
      });
    });
  },
  [UPDATE_PASSWORD_USER_ADMIN](context, payload) {
    let userId = payload[0];
    payload = payload[1];
    return ApiService.patch(`/admin/users/${userId}/password`, payload).then(
      ({ data }) => {
        return data;
      }
    );
  }
};

const mutations = {
  [SET_ADMIN_USERS](state, adminUsers) {
    state.adminUsers = adminUsers;
  },
  [SET_ADMIN_USERS_PAGINATION](state, data) {
    state.adminUsersPagination = data;
  },
  [SET_ADMIN_USERS_PAGINATION_PAGE](state, page) {
    state.adminUsersPagination.currentPage = page;
  },
  [SET_ADMIN_USERS_SORT](state, payload) {
    state.sort = payload;
  },
  [SET_ADMIN_USER](state, adminUser) {
    state.adminUser = adminUser;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
